export const DescriptionPanel = ({message}: {message: string}) => {
  return (
      <div className="bg-contrast bg-opacity-10 p-3 px-4 rounded-lg">
          {message}
      </div>
  )
}